import React from 'react';
import PropTypes from 'prop-types';
import Favorite, { FAVORITE_PLUS } from 'components/Favorite';
import { getShowType } from 'helpers/ContentHelper';
import { PageNames, SegmentSources, tealiumEventPageTypes } from '@foxcorp/delta-web-analytics';
import Style from './ActionButton.module.scss';

const FavoriteButton = ({
  manager,
  seriesName,
  showCode,
  favoritableItems,
  network,
  seriesType,
  recommendationId,
}) => {
  const { global_watchlistButton, global_watchlistSetButton } = window.Language;

  const actionLocation = tealiumEventPageTypes?.[PageNames.LIVE];
  const location = tealiumEventPageTypes?.[PageNames.FAVORITES_LIVE];
  const showType = getShowType({ seriesType });
  const defaultText = global_watchlistButton;
  const favoritedText = global_watchlistSetButton;
  const iconType = FAVORITE_PLUS;

  const data = {
    actionLocation,
    favoritableItems,
    favoriteType: showType,
    location,
    networkId: network,
    recommendationId,
    seriesName,
    showID: showCode,
    source: SegmentSources.DETAIL,
  };

  const favorites = manager?.favorites;

  const favoriteButtonProps = {
    data,
    defaultText,
    favoritedText,
    favorites,
    iconType,
    isEpgFavorite: true,
    manager,
    theme: Style,
  };

  return (
    <div className={Style.favoriteButton}>
      <div className={Style.actionLink}>
        <Favorite {...favoriteButtonProps} />
      </div>
    </div>
  );
};

FavoriteButton.propTypes = {
  manager: PropTypes.shape({}).isRequired,
  favoritableItems: PropTypes.arrayOf(PropTypes.shape({})),
  showCode: PropTypes.string,
  seriesName: PropTypes.string,
  network: PropTypes.string,
  seriesType: PropTypes.string,
  recommendationId: PropTypes.string,
};

export default FavoriteButton;
